import React from 'react';
import { ClipboardList } from 'lucide-react';
import WalkinContactSection from './WalkinContactSection';
import WalkinIdentitySection from './WalkinIdentitySection';
import WalkinVisitSection from './WalkinVisitSection';
import WalkinFeeSection from './WalkinFeeSection';

/** Long, sectioned walk-in registration form (booking-style, reception UX). */
export default function WalkinRegistrationForm({ form, selectedSession, docName }) {
  return (
    <div className="space-y-4" data-testid="walkin-registration-form">
      <header className="rounded-2xl border border-[#D5DEE8] bg-gradient-to-br from-[#071B34] to-[#0C2744] text-white px-5 py-4 shadow-sm">
        <div className="flex items-start gap-3">
          <div className="h-10 w-10 rounded-xl bg-[#F15A22] flex items-center justify-center shrink-0">
            <ClipboardList className="h-5 w-5 text-white" />
          </div>
          <div>
            <p className="text-[10px] uppercase tracking-[0.18em] text-[#C4A35A] font-bold">Walk-in registration</p>
            <h2 className="font-heading text-xl mt-0.5">Register a walk-in visit</h2>
            <p className="text-[12px] text-[#B8C7D6] mt-1 leading-relaxed max-w-xl">
              Same clarity as online booking — one long form with clear sections.
              Phone or email lookup fills known patients. Queue number is issued after triage.
            </p>
          </div>
        </div>
      </header>
      <WalkinContactSection form={form} />
      <WalkinIdentitySection form={form} />
      <WalkinVisitSection form={form} selectedSession={selectedSession} docName={docName} />
      <WalkinFeeSection form={form} />
    </div>
  );
}
